import { useState } from "react";
import AgentTableView from "./AgentTableView";
import AgentEmptyState from "./AgentEmptyState";
import AddAgent from "./AddAgent";
import AddDiscoveryAgent from "./AddDiscoveryAgent";

// Mock cloud provider data (will be replaced with API call)
const mockCloudProviders = {
  accounts: [
    {
      id: 'a4d5a977-2452-4e11-94e4-f644ab7ef4fb',
      name: 'Amazon Web Services',
      categories: [
        {
          id: '1',
          name: 'Single Account',
          code: 'single_aws',
          description: 'Connect a single AWS account for scanning'
        },
        {
          id: '2',
          name: 'Organization',
          code: 'org_aws',
          description: 'Connect AWS Organization for multi-account scanning'
        }
      ]
    },
    {
      id: 'b9b3e8cf-af69-4b37-bfae-dfa309338b02',
      name: 'Microsoft Azure',
      categories: [
        {
          id: '3',
          name: 'Single Subscription',
          code: 'single_azure',
          description: 'Connect a single Azure subscription'
        }
      ]
    },
    {
      id: 'a4745294-2a79-451b-a4ef-139119e2f78e',
      name: 'Google Cloud Platform',
      categories: [
        {
          id: '4',
          name: 'Single Project',
          code: 'single_gcp',
          description: 'Connect a single GCP project'
        }
      ]
    }
  ]
};

const CloudAgent2 = () => {
  const [isAddAgentCardOpen, setIsAddAgentCardOpen] = useState(false);
  const [isAddCloudAgentOpen, setIsAddCloudAgentOpen] = useState(false);
  const [showEmptyState, setShowEmptyState] = useState(false); // Toggle to show empty state or table

  const handleAddAgentSubmit = async (dataToSend: any) => {
    console.log("Agent created:", dataToSend);
    // After creating agent, show table view
    setShowEmptyState(false);
    setIsAddAgentCardOpen(false);
    setIsAddCloudAgentOpen(false);
  };

  return (
    <>
      {showEmptyState ? (
        <AgentEmptyState
          onCreateAgent={() => setIsAddAgentCardOpen(true)}
        />
      ) : (
        <AgentTableView />
      )}

      {/* Add Agent Modals */}
      {isAddAgentCardOpen && (
        <AddAgent
          isOpen={isAddAgentCardOpen}
          onClose={() => setIsAddAgentCardOpen(false)}
          addAgentList={mockCloudProviders}
          onSubmit={handleAddAgentSubmit}
        />
      )}
      {isAddCloudAgentOpen && (
        <AddDiscoveryAgent
          isOpen={isAddCloudAgentOpen}
          onClose={() => setIsAddCloudAgentOpen(false)}
          addAgentList={mockCloudProviders}
          onSubmit={handleAddAgentSubmit}
        />
      )}
    </>
  );
};

export default CloudAgent2;
